import { get } from 'lodash';
import React from 'react';
import { Form } from 'src/components/Antd';
import { Select } from 'src/components/Antd/Select';
import CommonAmount from 'src/constrains/AdvancedFilters/Components/CommonAmount';
import {
  IFulfillmentStatus,
  IOrderStatus,
  IPaymentStatus,
} from 'src/types/common/order';
import css from './css.module.less';

import { useI18n } from 'src/hooks/useRouterChange';
import { getI18nFromGeneral, i18nGet } from 'src/tools/tools';

const orderStatusList = [
  {
    value: IOrderStatus.DRAFT,
    label: getI18nFromGeneral('general.status.draft'),
  },
  {
    value: IOrderStatus.ACTIVE,
    label: getI18nFromGeneral('general.status.active'),
  },
  // {
  //   value: IOrderStatus.COMPLETED,
  //   label: getI18nFromGeneral('general.status.completed'),
  // },
  {
    value: IOrderStatus.COMPLETED, // IOrderStatus.COMPLETE,
    label: getI18nFromGeneral('general.status.complete'),
  },
  {
    value: IOrderStatus.SUSPENDED,
    label: getI18nFromGeneral('general.status.suspended'),
  },
  {
    value: IOrderStatus.CANCELLED,
    label: getI18nFromGeneral('general.status.cancelled'),
  },
];

const paymentStatusList = [
  {
    value: IPaymentStatus.PENDING,
    label: getI18nFromGeneral('general.paymentStatus.pending'),
  },
  {
    value: IPaymentStatus.FAILED,
    label: getI18nFromGeneral('general.paymentStatus.failed'),
  },
  {
    value: IPaymentStatus.PAID,
    label: getI18nFromGeneral('general.status.paid'),
  },
  // {
  //   value: IPaymentStatus.PARTIAL_REFUNDED,
  //   label: getI18nFromGeneral('general.paymentStatus.partReturn'),
  // },
  {
    value: IPaymentStatus.REFUND_REQUESTED,
    label: getI18nFromGeneral('general.paymentStatus.refundRequest'),
  },
  {
    value: IPaymentStatus.REFUND_APPROVED,
    label: getI18nFromGeneral('general.paymentStatus.refundApproved'),
  },
  {
    value: IPaymentStatus.REFUNDED_REJECTED,
    label: getI18nFromGeneral('general.paymentStatus.refundRejected'),
  },
  {
    value: IPaymentStatus.RETURNING_IN_PROGRESS,
    label: getI18nFromGeneral('general.paymentStatus.returnInProgress'),
  },
  {
    value: IPaymentStatus.RETURN_RECEIVED,
    label: getI18nFromGeneral('general.paymentStatus.returnReceived'),
  },
  {
    value: IPaymentStatus.REFUND_CONFIRMED,
    label: getI18nFromGeneral('general.paymentStatus.refundConfirmed'),
  },
  {
    value: IPaymentStatus.PARTIAL_REFUNDED,
    label: getI18nFromGeneral('general.paymentStatus.partialRefund'),
  },
  {
    value: IPaymentStatus.RETURN_DELIVERY_CONFIRMED,
    label: getI18nFromGeneral('general.status.returnDC'),
  },
  {
    value: IPaymentStatus.REFUND_ERROR,
    label: getI18nFromGeneral('general.paymentStatus.refundError'),
  },
  {
    value: IPaymentStatus.REFUNDED,
    label: getI18nFromGeneral('general.status.refunded'),
  },
  {
    value: IPaymentStatus.NONE,
    label: getI18nFromGeneral('general.status.none'),
  },
  {
    value: IPaymentStatus.RETURN_REQUESTED,
    label: getI18nFromGeneral('general.status.returnRequested'),
  },
  {
    value: IPaymentStatus.RETURN_CONFIRMED,
    label: getI18nFromGeneral('general.paymentStatus.returnConfirmed'),
  },
  {
    value: IPaymentStatus.RETURN_APPROVED,
    label: getI18nFromGeneral('general.paymentStatus.returnApproved'),
  },
  {
    value: IPaymentStatus.RETURN_REJECTED,
    label: getI18nFromGeneral('general.paymentStatus.returnRejected'),
  },
  {
    value: IPaymentStatus.PARTIAL_RETURNED,
    label: getI18nFromGeneral('general.paymentStatus.partReturn'),
  },
  {
    value: IPaymentStatus.RETURNED,
    label: getI18nFromGeneral('general.status.returned'),
  },
];

const fulfillmentStatusList = [
  {
    value: IFulfillmentStatus.OUT_OF_STOCK,
    label: getI18nFromGeneral('general.status.outofStock'),
  },
  {
    value: IFulfillmentStatus.READY_TO_PICK,
    label: getI18nFromGeneral('general.status.ready2Pick'),
  },
  {
    value: IFulfillmentStatus.READY_TO_PACK,
    label: getI18nFromGeneral('general.status.ready2Pack'),
  },
  {
    value: IFulfillmentStatus.READY_TO_SHIP,
    label: getI18nFromGeneral('general.status.ready2Ship'),
  },
  {
    value: IFulfillmentStatus.READY_TO_COLLECT,
    label: getI18nFromGeneral('general.status.ready2Collect'),
  },
  {
    value: IFulfillmentStatus.DELIVERING,
    label: getI18nFromGeneral('general.status.delivering'),
  },
  {
    value: IFulfillmentStatus.DELIVERED,
    label: getI18nFromGeneral('general.status.delivered'),
  },
  {
    value: IFulfillmentStatus.NOTIFIED,
    label: getI18nFromGeneral('general.status.notified'),
  },
  {
    value: IFulfillmentStatus.COLLECTED,
    label: getI18nFromGeneral('general.status.collected'),
  },
  {
    value: IFulfillmentStatus.ERROR,
    label: getI18nFromGeneral('general.paymentStatus.error'),
  },
];

enum EOrderStatus {
  ALL = 'ALL',
}

const transferDataFromServer = (orderStatus) => {
  const allStatus = get(orderStatus, 'allStatus');
  if (allStatus) {
    return EOrderStatus.ALL;
  }
  const _orderStatus = get(orderStatus, 'orderStatus');
  if (_orderStatus) {
    return _orderStatus;
  }
  const _paymentStatus = get(orderStatus, 'paymentStatus');
  if (_paymentStatus) {
    return _paymentStatus;
  }
  const _fulfillmentStatus = get(orderStatus, 'fulfillmentStatus');
  if (_fulfillmentStatus) {
    return _fulfillmentStatus;
  }
  return null;
};

const transferDataFromForm = (conditions) => {
  const orderStatus = get(conditions, 'orderStatus');
  if (orderStatus === EOrderStatus.ALL) {
    return {
      allStatus: true,
      orderStatus: null,
      paymentStatus: null,
      fulfillmentStatus: null,
    };
  }
  const isOrder = orderStatusList.find((i) => i.value === orderStatus);

  if (isOrder) {
    return {
      allStatus: false,
      orderStatus: orderStatus,
      paymentStatus: null,
      fulfillmentStatus: null,
    };
  }
  const isPayment = paymentStatusList.find((i) => i.value === orderStatus);
  if (isPayment) {
    return {
      allStatus: false,
      orderStatus: null,
      paymentStatus: orderStatus,
      fulfillmentStatus: null,
    };
  }
  const isFulfillment = fulfillmentStatusList.find(
    (i) => i.value === orderStatus,
  );
  if (isFulfillment) {
    return {
      allStatus: false,
      orderStatus: null,
      paymentStatus: null,
      fulfillmentStatus: orderStatus,
    };
  }
  return {
    allStatus: false,
    orderStatus: null,
    paymentStatus: null,
    fulfillmentStatus: null,
  };
};
export { EOrderStatus, transferDataFromForm, transferDataFromServer };

const Item = Form.Item;
const Option = Select.Option;
const OptGroup = Select.OptionGroup;

const TotalOrderAmount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    noStyle,
    nameType,
    nameValue,
    nameRange,
    rules,
    suffix,
    selectName,
    disabled,
  } = props;
  return (
    <React.Fragment>
      <Item name={selectName} noStyle={noStyle}>
        <Select
          //getPopupContainer={() => document.body}
          size='large'
          className={css.select}
          disabled={disabled}
          placeholder={getI18n(
            'general.advancedFilters.orderAmount.placeholder',
          )}>
          <Option value={EOrderStatus.ALL} key={EOrderStatus.ALL}>
            {getI18n('general.sider.allOrders')}
          </Option>
          <OptGroup label={getI18n('general.orderAmount.orderStatus')}>
            {orderStatusList.map((i) => {
              return (
                <Option value={i.value} key={i.value}>
                  {i.label}
                </Option>
              );
            })}
          </OptGroup>
          <OptGroup label={getI18n('general.orderAmount.paymentStatus')}>
            {paymentStatusList.map((i) => {
              return (
                <Option value={i.value} key={i.value}>
                  {i.label}
                </Option>
              );
            })}
          </OptGroup>
          <OptGroup label={getI18n('general.orderAmount.fulfillmentStatus')}>
            {fulfillmentStatusList.map((i) => {
              return (
                <Option value={i.value} key={i.value}>
                  {i.label}
                </Option>
              );
            })}
          </OptGroup>
        </Select>
      </Item>
      <Item
        shouldUpdate={(p, c) => {
          const cT = get(c, selectName);
          const pT = get(p, selectName);
          return cT !== pT;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const select = getFieldValue(selectName);
          if (!!select) {
            return (
              <CommonAmount
                isTypeRequired
                noStyle={noStyle}
                nameType={nameType}
                nameValue={nameValue}
                nameRange={nameRange}
                rules={rules}
                suffix={suffix}
                disabled={disabled}
              />
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default TotalOrderAmount;
